import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {WEBSITE_MODULE} from "../website-module.consts";
import {WebsiteModuleState} from "../models/website-module.state";
import {BaseController} from "../../../infrastructure/controllers/base-controller";
import {action, runInAction} from "mobx"
import {MetadataManager} from "../../../core/managers/metadata.manager";
import {APP} from "../../../core/app/consts";
import {AdAdapexManager} from "../../../core/managers/ads/ad.adapex.manager";

export class WebsiteModuleRouteChangeHandler extends ActionHandler {
  state: WebsiteModuleState;
  initialRoute: Boolean = true;
  metadataManager: MetadataManager;
  adAdapexManager: AdAdapexManager;
  currentRouteName: String;

  static injectables = [...ActionHandler.injectables, MetadataManager, AdAdapexManager];

  constructor(metadataManager: MetadataManager, adAdapexManager: AdAdapexManager) {
    super();

    this.type = WEBSITE_MODULE.ACTION_TYPES.onRouteChange
    this.metadataManager = metadataManager;
    this.adAdapexManager = adAdapexManager;
  }

  @action action(params) {
    if (this.currentRouteName && (this.currentRouteName !== params.route.name)) {
      this.adAdapexManager.canRefresh = false;
    }

    if (this.shouldFetchMetadata) {
      this.fetchMetadata()
    }

    if (this.state.pageMetadata) {
      runInAction(() => {
        this.state.pageMetadata._metaData = params.route.metadata;
      });
    }

    this.currentRouteName = params.route.name;
    this.initialRoute = false;
  }

  onRenderComplete(controller: BaseController) {
    super.onRenderComplete();

    this.state.isMainScreenRendered = true;
  }

  get shouldFetchMetadata() {
    const isValidLanguage: Boolean = this.metadataManager.isValidLanguage(this.state.language.id);
    const routeName: String = this.state.currentLinkModel?.name;
    const isOnTv: Boolean = this.state.currentLinkModel.params.sportName === APP.ANALYTICS.SOURCES.whereToWatch

    const isValidRoute: Boolean = !isOnTv && isValidLanguage && this.metadataManager.validRoutes.includes(routeName);

    return isValidRoute
  }

  fetchMetadata() {
    if (this.state.isGameRoute) {
      this.state.entitiesContext.registerToGameExist('FetchGameCenterMetadata', () =>
        this.controller.action(WEBSITE_MODULE.ACTION_TYPES.fetchMetadata))
    } else {
      this.controller.action(WEBSITE_MODULE.ACTION_TYPES.fetchMetadata);
    }
  }
}
